import { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';

const navLinks = [
  { path: '/', label: '首页', icon: 'ri-home-4-line' },
  { path: '/category/zonghe', label: '综合平台', icon: 'ri-global-line' },
  { path: '/category/dianying', label: '电影专区', icon: 'ri-film-line' },
  { path: '/category/dianshiju', label: '电视剧集', icon: 'ri-tv-line' },
  { path: '/category/jilupian', label: '纪录片库', icon: 'ri-camera-lens-line' },
  { path: '/about', label: '关于我们', icon: 'ri-information-line' },
];

export default function Navbar() {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileOpen, setIsMobileOpen] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 20);
    };
    window.addEventListener('scroll', handleScroll, { passive: true });
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  useEffect(() => {
    setIsMobileOpen(false);
  }, [location.pathname]);

  useEffect(() => {
    document.body.style.overflow = isMobileOpen ? 'hidden' : '';
    return () => { document.body.style.overflow = ''; };
  }, [isMobileOpen]);

  return (
    <>
      <nav
        className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
          isScrolled
            ? 'bg-background-50/95 backdrop-blur-md border-b border-background-200/70'
            : 'bg-transparent'
        }`}
      >
        <div className="w-full px-4 md:px-6">
          <div className="flex items-center justify-between h-16">
            <Link to="/" className="flex items-center gap-2 whitespace-nowrap cursor-pointer">
              <span className="w-8 h-8 flex items-center justify-center rounded-lg bg-primary-500">
                <i className="ri-play-circle-fill text-background-50 text-lg"></i>
              </span>
              <span className={`font-heading font-semibold text-lg transition-colors duration-300 ${
                isScrolled ? 'text-foreground-900' : 'text-background-50'
              }`}>
                免费看片推荐
              </span>
            </Link>

            <div className="hidden md:flex items-center gap-1">
              {navLinks.map((link) => {
                const isActive = link.path === '/'
                  ? location.pathname === '/'
                  : location.pathname.startsWith(link.path);
                return (
                  <Link
                    key={link.path}
                    to={link.path}
                    className={`px-3 py-2 rounded-lg text-sm font-medium whitespace-nowrap transition-colors duration-200 cursor-pointer ${
                      isActive
                        ? 'bg-primary-500 text-background-50'
                        : isScrolled
                          ? 'text-foreground-700 hover:text-foreground-900 hover:bg-background-100'
                          : 'text-background-50/90 hover:text-background-50 hover:bg-white/10'
                    }`}
                  >
                    {link.label}
                  </Link>
                );
              })}
            </div>

            <button
              onClick={() => setIsMobileOpen(!isMobileOpen)}
              className="md:hidden w-10 h-10 flex items-center justify-center rounded-lg cursor-pointer"
              aria-label="菜单"
            >
              <i className={`text-xl transition-colors duration-300 ${
                isScrolled ? 'text-foreground-900' : 'text-background-50'
              } ${isMobileOpen ? 'ri-close-line' : 'ri-menu-line'}`}></i>
            </button>
          </div>
        </div>
      </nav>

      {isMobileOpen && (
        <div className="fixed inset-0 z-40 md:hidden">
          <div
            className="absolute inset-0 bg-foreground-950/50 backdrop-blur-sm"
            onClick={() => setIsMobileOpen(false)}
          />
          <div className="absolute top-16 left-0 right-0 bg-background-50 border-b border-background-200/70 p-4">
            <div className="flex flex-col gap-1">
              {navLinks.map((link) => {
                const isActive = link.path === '/'
                  ? location.pathname === '/'
                  : location.pathname.startsWith(link.path);
                return (
                  <Link
                    key={link.path}
                    to={link.path}
                    className={`flex items-center gap-3 px-4 py-3 rounded-lg text-sm font-medium transition-colors cursor-pointer ${
                      isActive
                        ? 'bg-primary-500 text-background-50'
                        : 'text-foreground-700 hover:bg-background-100 hover:text-foreground-900'
                    }`}
                  >
                    <i className={`${link.icon} text-base`}></i>
                    {link.label}
                  </Link>
                );
              })}
            </div>
          </div>
        </div>
      )}
    </>
  );
}